import { confirmDialog } from "primereact/confirmdialog";
import "primereact/confirmdialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";

const showDialog = ({
  title = "Are you sure?",
  message = "",
  type = "warn", // "warn", "error", "success", "info"
  onAccept = () => {},
  onReject = () => {},
}) => {
  let icon = "pi pi-exclamation-triangle";
  let header = "Confirmation";

  switch (type) {
    case "success":
      icon = "pi pi-check-circle";
      header = "Success";
      break;
    case "error":
      icon = "pi pi-times-circle";
      header = "Error";
      break;
    case "info":
      icon = "pi pi-info-circle";
      header = "Information";
      break;
    case "warn":
    default:
      icon = "pi pi-exclamation-triangle";
      header = "Confirmation";
  }

  confirmDialog({
    header,
    message: message || title,
    icon,
    accept: onAccept,
    reject: onReject,
    closable: false,
    appendTo: document.body,
    style: { zIndex: 10000, minWidth: "350px" },
  });
};

const CustomDialog = {
  warn: (title, onAccept, onReject) =>
    showDialog({ title, onAccept, onReject, type: "warn" }),
  confirm: (title, onAccept, onReject) =>
    showDialog({ title, onAccept, onReject, type: "warn" }),
};

export default CustomDialog;
